import type { SVGProps } from "react";
export interface LightbulbOnIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LightbulbOnIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LightbulbOnIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m16 16.875.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005H8a1.125 1.125 0 0 1 0-2.25zm-12.478-3.5a1.125 1.125 0 0 1-.026 2.25h-.01a1.125 1.125 0 0 1 .026-2.25zm16.983 2.25a1.124 1.124 0 1 1-.027-2.25zm-.017-2.25a1.125 1.125 0 0 1 .028 2.25h-.01l-.014-1.126-.015-1.123zM10.876 14v-1.438L9.324 11.4a1.125 1.125 0 0 1 1.35-1.8l1.325.993 1.326-.993a1.125 1.125 0 0 1 1.35 1.8l-1.55 1.162V14a1.126 1.126 0 0 1-2.25 0ZM1.97 7.874a1.126 1.126 0 0 1 .306 2.218l-.113.022h-.01a1.125 1.125 0 1 1-.308-2.228l.01-.002zm20.029 0 .115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-.01a1.125 1.125 0 0 1 0-2.25H22ZM3.506 4.624a1.125 1.125 0 0 1-.016-2.25zM3.5 2.375l.116.005a1.126 1.126 0 0 1 .016 2.239l-.116.007h-.01L3.499 3.5l-.01-1.125zm16.985 2.25a1.125 1.125 0 0 1 .013-2.25zm.023-2.25a1.125 1.125 0 0 1-.013 2.25h-.01l.007-1.124.006-1.125z"
      />
      <path
        fill={color}
        d="M17.874 9a5.875 5.875 0 1 0-11.75 0 6.6 6.6 0 0 0 1.293 3.873l.303.42c.711 1.02 1.405 2.308 1.405 3.793V19c0 1.035.84 1.875 1.875 1.875h2c1.035 0 1.874-.84 1.874-1.875v-1.914c0-1.697.906-3.137 1.71-4.212A6.6 6.6 0 0 0 17.874 9m2.25 0a8.84 8.84 0 0 1-1.738 5.22c-.762 1.02-1.261 1.95-1.262 2.866V19A4.125 4.125 0 0 1 13 23.125h-2A4.125 4.125 0 0 1 6.876 19v-1.914c0-.802-.383-1.615-.989-2.488l-.272-.378A8.83 8.83 0 0 1 3.874 9a8.126 8.126 0 0 1 16.25 0"
      />
    </svg>
  );
}
